import {AbstractAdminEntityService} from "./AbstractAdminEntityService";
import {AdminUser, ListAdminUsersResponse} from "../http/protocol";
import {HttpService} from "../http/HttpService";


export class AdminUserService extends AbstractAdminEntityService<AdminUser, ListAdminUsersResponse> {

    constructor(http: HttpService) {
        super("/admin-user", http);
    }

    resetPassword(userId?: number): Promise<AdminUser> {
        return this.http.get(this.entityPath + "/reset-password/" + userId);
    }

}